import { Image } from '@domain-group/suit-theme'

import type { CampaignModel } from '@models/types'

import PlaceHolderImageUrl from '@assets/campaign_image_400x400.png'

interface CampaignImageProps {
  borderRadius?: number,
  campaign: CampaignModel,
  circle?: boolean,
  height?: number,
  width?: number,
}

const CampaignImage = (props: CampaignImageProps) => {
  const {
    borderRadius, campaign, circle = false, height = 40, width = 40,
  } = props

  // @ts-expect-error TS7006
  const getBorderRadius = (borderRadius, circle) => {
    if (borderRadius) return borderRadius
    if (circle) return '100%'
    return undefined
  }

  return (
    <Image
      backgroundSize="cover"
      borderRadius={getBorderRadius(borderRadius, circle)}
      placeholderUrl={PlaceHolderImageUrl}
      url={campaign.default_image}
      height={height}
      width={width}
    />
  )
}

export default CampaignImage
